import {register} from "@shopify/theme-sections"
import '../../styles/sections/banner-with-text.scss'

export default register(`banner-with-text`, {
    onLoad() {

    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload() {
    },
})
